export const INITIAL_STATE_FILE = {
  id: "",
  idConta: "",
  file: "",
  tipoArquivo: "",
  descricao: "",
  keyAws: "",
  urlArquivo: "",
}